
import Categories from 'src/views/Pages/Dashboard/Assistance/Category/Index.vue'
import EditCreate from 'src/views/Pages/Dashboard/Assistance/Category/EditCreate.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import IndexAssistance from 'src/views/Pages/Dashboard/Assistance/Index.vue';
import Status from 'src/views/Pages/Dashboard/Assistance/Status/Index.vue';

const AssistanceRoutes = {
  path: 'assistance',
  component: IndexAssistance,
  children: [
    {
      path: 'status',
      name: 'Estados',
      component: Status,
      meta: {
        prefix_permission: 'assistance_status',
      },
    },
    {
      path: 'category',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Categorías',
          component: Categories,
          meta: {
            prefix_permission: 'assistance_category',
          },
        },
        {
          path: 'create',
          name: 'Categorías',
          component: EditCreate,
          meta: {
            prefix_permission: 'assistance_category',
          },
        },
      ],
    },
  ],
};

export default AssistanceRoutes;
